import { Flex, ThemeType } from '@gmg/gmg-react-components';
import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import GmgLogoDark from '../assets/svg/gmg_dark.svg';
import GmgLogoLight from '../assets/svg/gmg_light.svg';
import ErrorMsg, { ApplicationError } from './errorHandling/ErrorMsg';

interface PublicFrameProps {
    errorType: ApplicationError | undefined;
    theme: ThemeType;
}

const PublicFrame: FunctionComponent<PublicFrameProps> = props => {

    return (
        <Flex
            alignItems="space-between"
            flexDirection="column"
        >
            <Header>
                {props.theme === 'dark'
                    ? <GmgLogoDark width={78} height={28} />
                    : <GmgLogoLight width={78} height={28} />
                }
            </Header>

            <Flex flexDirection="column" alignItems="center" bg="backgroundPaper" pt="40px">
                <Flex
                    flexDirection="column"
                    justifyContent="flex-start"
                    alignItems="space-between"
                >
                    {props.errorType
                        ? <ErrorMsg errorType={props.errorType} />
                        : <Outlet />
                    }
                    <Flex
                        height="calc(100vh - 404px)">
                        {/* TODO: test : set parent to 100vh 100 vw or flexgrow: 2 and remove this FlexBox */}
                    </Flex>
                </Flex>
            </Flex>


        </Flex>
    );
};

const Header = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    padding-right: 32px;
    padding-left: 16px;
    background-color: ${props => props.theme.colors.background};
`;

export default PublicFrame;
